<!-- <div class="loading-indicator">
  <mat-spinner mode="indeterminate" color="accent"></mat-spinner>
</div> -->
<!-- <div id="_loading" class="es-loading-indicator -es-fullscreen -es-visible">
  <span class="es-loading-icon"></span>
</div> -->

<div id="_loading" class="es-loading-indicator -es-fullscreen  -es-visible">
  <span class="es-loading-icon"></span>
</div>